type LeadQueryResponseData = {
    searchCreateLead: {
        success: boolean;
        message: string | null;
        leadId: number;
        leadToken: string;
        rxSessionId: string;
    };
};

export const createLead = async (
    {
        email,
        allianceId,
        profileId,
        adobeMid,
        savedSessionCode1,
        fullEhivisitorId,
        advertiseSource,
        leadAddress,
        leadPhone,
        leadMember,
    }: LeadRequestArgs,
    { disclaimerText, disclaimerUrl, visitTime, userAgent }: ITcpaInput
) => {
    const leadMembersArg = leadMember?.firstName || leadMember?.lastName ? [leadMember] : undefined;
    const leadPhonesArg = leadPhone?.phoneNumber ? [leadPhone] : undefined;
    const leadAddressesArg = leadAddress?.zipCode && leadAddress.county ? [leadAddress] : undefined;
    const medicareLeadExtensionArg = savedSessionCode1
        ? { rxSessionId: savedSessionCode1 }
        : undefined;

    return await fetch(`${process.env.GATSBY_CC_GQL_URL}/graphql`, {
        method: 'POST',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Method': 'POST',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: `
                mutation searchCreateLead(
                    $email: String
                    $allianceId: String
                    $profileId: String
                    $medicareLeadExtension: MedicareLeadExtension
                    $adobeMid: String
                    $fullEhivisitorId: String
                    $advertiseSource: String
                    $disclaimerText: String
                    $disclaimerUrl: String
                    $visitTime: String
                    $userAgent: String
                    $leadMembers: [LeadMembers]
                    $leadPhones: [LeadPhone]
                    $leadAddresses: [LeadAddress]
                ) {
                    searchCreateLead(
                        input: {
                            email: $email
                            allianceId: $allianceId
                            profileId: $profileId
                            adobeMid: $adobeMid
                            medicareLeadExtension: $medicareLeadExtension
                            fullEhivisitorId: $fullEhivisitorId
                            advertiseSource: $advertiseSource
                            leadAddresses: $leadAddresses
                            leadPhones: $leadPhones
                            leadMembers: $leadMembers
                        }
                        tcpaInput: {
                            disclaimerText: $disclaimerText
                            disclaimerUrl: $disclaimerUrl
                            visitTime: $visitTime
                            userAgent: $userAgent
                        }
                    ) {
                        success
                        message
                        leadId
                        leadToken
                        rxSessionId
                    }
                }
            `,
            variables: {
                email: email,
                allianceId: allianceId,
                profileId: profileId,
                adobeMid: adobeMid,
                medicareLeadExtension: medicareLeadExtensionArg,
                fullEhivisitorId: fullEhivisitorId,
                advertiseSource: advertiseSource,
                leadAddresses: leadAddressesArg,
                leadPhones: leadPhonesArg,
                leadMembers: leadMembersArg,
                disclaimerText,
                disclaimerUrl,
                visitTime,
                userAgent,
            },
        }),
    }).then((res): Promise<{ data: LeadQueryResponseData }> => res.json());
};
